import type { Element } from '@xmldom/xmldom'
import L6ToL5TagProcessor from "./TagProcessor"
import { DefaultProps, applyDefaultCid, applyDefaultSubconceptCid } from "./DefaultProps"
import { CidPath } from '../../concept/Concept'

class BooleanTagProcessor extends L6ToL5TagProcessor {
	processBoolean(node: Element, xpath: string, baseCidPath: CidPath, defaultProps: DefaultProps) {
		if(!this.rootProc.translateDirItemId(node, 'dirItemId', 'cid', true)) {
			return
		}
		applyDefaultCid(node, defaultProps)
		applyDefaultSubconceptCid(node, defaultProps)
		if(node.hasAttribute('subconceptCid')) {
			// subconcept boolean
			let [concept, subconcept] = this.rootProc.getSubconcept(node, xpath, baseCidPath)
			if(concept !== null && subconcept !== null) {
				concept.subconcepts.push(subconcept.cid)
			}
		} else {
			// concept boolean
			this.rootProc.getConcept(node, xpath, baseCidPath)
		}
	}

	processCheck(node: Element, xpath: string, baseCidPath: CidPath, defaultProps: DefaultProps) {
		node.setAttribute('valueDataType', 'check')
		this.processBoolean(node, xpath, baseCidPath, defaultProps)
	}
}

export default BooleanTagProcessor
